module.exports = __webpack_public_path__ + "static/media/7_Peace of mind_FA.ce686503.txt";